import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Domains } from "@/components/site/Domains";
import { Founder } from "@/components/site/Founder";
import { Prestations } from "@/components/site/Prestations";
import { Estimator } from "@/components/site/Estimator";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <Marquee />
      <Domains />
      <Founder />
      <Prestations />
      <Estimator />
      <Faq />
      <Contact />
      <Footer />
    </main>
  );
}
